import { Component } from 'react';
import styled from 'styled-components';
import { DefaultTheme } from '../themes/DefaultTheme';

const ItemElement = styled.li`
  margin: 0;
  cursor: pointer;
  display: block;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  color: #1a1d1f;
  font-size: 16px;
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 0.8rem 1.1rem;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: normal;
  background-color: white;
  text-decoration: none;

  &:hover {
    background-color: ${DefaultTheme.dropdown.menuItem.hoverBgColor};
  }
`;

export interface IProps {
  onClick?: (e: any) => void;
  closeMenu?: () => void;
}

export class SearchDropdownMenuItem extends Component<IProps> {
  public render() {
    return <ItemElement onClick={this.handleClick}>{this.props.children}</ItemElement>;
  }

  private handleClick = e => {
    if (this.props.closeMenu) {
      this.props.closeMenu();
    }
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };
}
